import { render, staticRenderFns } from "./_TagsManagementPane.vue?vue&type=template&id=4aad6eb8&scoped=true"
import script from "./_TagsManagementPane.vue?vue&type=script&lang=js"
export * from "./_TagsManagementPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aad6eb8",
  null
  
)

export default component.exports